import Image from "next/image";
import type { Avatar as AvatarPrimitive } from "radix-ui";
import type { ComponentProps } from "react";
import useAvatar from "@/lib/hooks/use-avatar";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

type BusinessLogoProps = {
  src?: string | Blob;
  seed?: string;
} & ComponentProps<typeof AvatarPrimitive.Root>;

export const BusinessLogo = ({
  src,
  seed = "default-seed",
  className,
  ...avatarProps
}: BusinessLogoProps) => {
  const avatar = useAvatar(seed);

  return (
    <Avatar className={cn("rounded-full", className)} {...avatarProps}>
      <AvatarImage src={src} />
      <AvatarFallback>
        {avatar ? (
          <Image
            src={avatar}
            alt="business logo"
            width={64}
            height={64}
            className="aspect-square size-full"
          />
        ) : null}
      </AvatarFallback>
    </Avatar>
  );
};
